export default __webpack_public_path__ + "static/media/badMeter.c8482b6c.png";